import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  DatePicker,
} from "@mui/material";

import axios from "axios";

function AddNewRecipes() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    user_id: "",
    category_id: "",
    category_name: "",
    post_name: "",
    mealType_name: "",
    title_name: "",
    totalrating: "",
    totalreviewrecipe_message: "",
    url: "",
    difficulty_level: "",
    dietary_info: "",
    cuisine: "",
    short_description: "",
    author_name: "",
    likes: "",
    tags: [],
    views: "",
    created_at: new Date(),
    updated_at: new Date(),
    is_featured: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/recipe/recipeadder`,
        formData
      );
      alert(response.data.message);
    } catch (error) {
      alert("Error: " + error.response.data.message);
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Add a Recipe
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* User ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="User ID"
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Category ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Category ID"
              name="category_id"
              value={formData.category_id}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              label="Total Rating"
              name="totalrating"
              value={formData.totalrating}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              label="review message"
              name="totalreviewrecipe_message"
              value={formData.totalreviewrecipe_message}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Category Name */}
          <Grid item xs={12}>
            <TextField
              label="Category Name"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Post Name */}
          <Grid item xs={12}>
            <TextField
              label="Post Name"
              name="post_name"
              value={formData.post_name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Meal Type */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Meal Type"
              name="mealType_name"
              value={formData.mealType_name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Title Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Title Name"
              name="title_name"
              value={formData.title_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Short Description */}
          <Grid item xs={12}>
            <TextField
              label="Short Description"
              name="short_description"
              value={formData.short_description}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Author Name */}
          <Grid item xs={12}>
            <TextField
              label="Author Name"
              name="author_name"
              value={formData.author_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Difficulty Level */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Difficulty Level"
              name="difficulty_level"
              value={formData.difficulty_level}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Dietary Info */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Dietary Info"
              name="dietary_info"
              value={formData.dietary_info}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Cuisine */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Cuisine"
              name="cuisine"
              value={formData.cuisine}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* URL */}
          <Grid item xs={12}>
            <TextField
              label="URL"
              name="url"
              value={formData.url}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Tags */}
          <Grid item xs={12}>
            <TextField
              label="Tags (comma separated)"
              name="tags"
              value={formData.tags.join(", ")}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tags: e.target.value.split(",").map((tag) => tag.trim()),
                })
              }
              fullWidth
            />
          </Grid>

          {/* Views */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Views"
              name="views"
              value={formData.views}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Likes */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Likes"
              name="likes"
              value={formData.likes}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Created At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Updated At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="updated_at"
              value={formData.updated_at}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Date Picker for Created At */}

          {/* Date Picker for Updated At */}

          {/* Featured Checkbox */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_featured}
                  onChange={handleChange}
                  name="is_featured"
                />
              }
              label="Is Featured?"
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Add Recipe
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

export default AddNewRecipes;
